import * as React from 'react';
import ISPVsList from './ISPVsList';
import { connect } from 'react-redux';
import { SPVsListRow } from './SPVsListRow';
import ISPV from '@market/components/SPVsList/ISPV';

import * as style from './SPVsListStyle.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

export class SPVsList extends React.Component<ISPVsList> {

  spvsData = () => {
    const { spvsList } = this.props;
    return (
      spvsList.length > 0 ?
        (
          <div className={[elements.tableContainer, style.tableContainer].join(' ')}>
            <div className={elements.tableHead}>
              <div className={elements.tableHeadRow}>
                <div className={[elements.tableHeader, style.spvsHeader].join(' ')}/>
                <div className={[elements.tableHeader, style.spvsHeader].join(' ')}>Name</div>
                <div className={[elements.tableHeader, style.spvsHeader].join(' ')}>Company</div>
                <div className={[elements.tableHeader, style.spvsHeader].join(' ')}>Last Price</div>
                <div className={[elements.tableHeader, style.spvsHeader].join(' ')}/>
                <div className={[elements.tableHeader, style.spvsHeader].join(' ')}/>
              </div>
            </div>
            <div className={[elements.tableBody, style.spvsTable].join(' ')}>
              {
                spvsList.map((spv: ISPV) => {
                  return <SPVsListRow key={spv.id} spv={spv} userSignedIn={this.props.userSignedIn} />;
                })
              }
            </div>
          </div>
        ) :
        <h1 className={style.noItems}>Sorry, There are currently no assets to trade</h1>
    );
  }

  render() {
    return (
      <div>
        {this.spvsData()}
      </div>
    );
  }

}

const mapStateToProps = (store: any) => {
  return {
    userSignedIn: store.secondaryMarketReducer.userSignedIn,
  };
};

export default connect(mapStateToProps)(SPVsList);

